import type { SpinResponse } from "@slot/client-engine";
import { MergeRoundBuilder } from "../../MergeRoundBuilder";
import { OFFLINE_ROUND } from "../offlineRound";

/** A dead spin with two FS on the board: one short of the free spins, and no cluster pays. */
export function noWin3(): SpinResponse {
  return new MergeRoundBuilder({ roundId: "merge-no-win-3", ...OFFLINE_ROUND })
    .baseSpin({
      board: [
        ["L4", "H2", "L1", "H4", "L4", "L4"],
        ["H4", "FS", "H1", "L1", "L1", "L3"],
        ["L3", "L2", "H3", "L3", "L1", "L3"],
        ["L1", "L1", "L2", "L3", "L2", "L1"],
        ["L1", "H2", "L2", "L1", "L2", "FS"],
        ["L4", "L4", "L1", "H1", "L4", "L2"],
      ],
      refill: [[], [], [], [], [], []],
    })
    .build();
}
